enum AppTypes {
    INIT_APP_LOADING = 'INIT_APP_LOADING',
    INIT_APP = 'INIT_APP',
    INIT_DISCONNECT_FLOW = 'INIT_DISCONNECT_FLOW',
    INIT_APP_ERROR = 'INIT_APP_ERROR',
    END_CHAT = 'END_CHAT',
    CUSTOMER_ENDED_CHAT = 'CUSTOMER_ENDED_CHAT',
    SET_MESSAGE_INPUT = 'SET_MESSAGE_INPUT',
    SET_AGENT_TYPING = 'SET_AGENT_TYPING',
    SET_BOT_TYPING = 'SET_BOT_TYPING',
    SET_MODE = 'SET_MODE',
    SET_END_CHAT_CONFIRM = 'SET_END_CHAT_CONFIRM',
    SET_AGENT_CONNECTED = 'SET_AGENT_CONNECTED',
    START_NEW_CHAT = 'START_NEW_CHAT',
    SET_CUSTOMER_ENDED_CHAT = 'SET_CUSTOMER_ENDED_CHAT',
    SET_LANGUAGE = 'SET_LANGUAGE',
    BATCH_UPDATE = 'APPSTATE_BATCH_UPDATE',
    CHAT_EVENT = 'CHAT_EVENT',
    SET_AUTO_TRANSLATE_CONFIRM = 'SET_AUTO_TRANSLATE_CONFIRM',
    SET_TRANSLATION_LANGUAGE = 'SET_TRANSLATION_LANGUAGE',
    SET_TRANSLATION_STATUS = 'SET_TRANSLATION_STATUS',
    SET_GLOBAL_PAGE_STATUS = 'SET_GLOBAL_PAGE_STATUS',
    SET_APP_TEXT_TRANSLATIONS = 'SET_APP_TEXT_TRANSLATIONS',
    SET_PENDING_ATTACHMENT = 'SET_PENDING_ATTACHMENT',
}

export default AppTypes
